var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-circle mx-2 fs-button",on:{"click":this.toggleFullScreen}},[_c('img',{attrs:{"src":require("@/assets/fullscreen.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }